import { withStyles } from "@material-ui/core";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import React from "react";
import InputForm from "../../../components/Input/InputForm";
import { ReactSelect } from "../../../components/Select/SelectSearch";
import InputDateForm from "../../../components/Input/InputDateForm";

const options = [
  { value: "SIM", label: "Sim" },
  { value: "NAO", label: "Não" },
];

const SexagemFetal = observer(({ classes, exameStore }) => {

  const handleChange  = (event, field) => {
    exameStore.exame[field]=event
  }

  return (
    <div className={classes.content}>
      <div className={classes.contentInput}>
        Data da ultima menstruação:*
        <InputDateForm
          id="pac-sxf-inp-dum"
          iconposition="end"
          classes={classes.inputDateForm}
          value={exameStore?.exame?.dataUltimaMenstruacao || ""}
          onChange={(e) => handleChange(e, "dataUltimaMenstruacao")}
        />
      </div>
      <div className={classes.contentInput}>
        Fertilização in vitro:*
        <ReactSelect
          id="pac-sxf-sel-fiv"
          options={options}
          value={exameStore?.exame?.fertilizacaoInVitro}
          classes={{ input: classes.input }}
          placeholder="Selecione"
          onChange={(e) => handleChange(e, "fertilizacaoInVitro")}
        />
      </div>
      <div className={classes.contentInput}>
        Idade gestacional em semanas:*
        <InputForm
          id="pac-sxf-inp-igs"
          type={"number"}
          value={exameStore?.exame?.idadeGestacionalSemanas}
          classes={{ input: classes.input }}
          placeholder="Semanas"
          onChange={(e) => handleChange(e?.target?.value, "idadeGestacionalSemanas")}
        />
      </div>
    </div>
  );
});

const styles = {
  content: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    gap: "10px",
    justifyContent: "flex-start",
    alignContent: "center",
    alignItems: "center",
  },
  span: {
    color: "#333333",
    fontSize: "16px",
    fontWeight: "bold",
    marginBottom: "5px",
  },
  contentInput: {
    gap: "5px",
    width: "240px",
    display: "flex",
    flexDirection: "column",
    color: "#868686",
  },
  input: {
    background: "#f2f2f2",
    border: "none",
    paddingTop: "6px !important",
    color: "#868686",
    width: "200px",
  },
};

export const SexagemFetalWithStyles = withStyles(styles)(SexagemFetal);
export default inject("exameStore")(SexagemFetalWithStyles);
